import React, { useEffect, useRef, useState } from "react";
import "./Auth.css";
import { useAuth } from "../../utils/AuthContext";
import { useNavigate } from "react-router-dom";
import { account } from "../../appwrite/appwriteConfig";
import logoPng from "../../assets/LogoDownload.png";
import { getBaseUrl } from "../../utils/getRedirectUrl";

export default function SignUp() {
    const registerForm = useRef(null);
    const setupForm = useRef(null);
    const {
        registerUser,
        authError,
        setChesscom,
        setAuthError,
        settingUp,
        user,
    } = useAuth();
    const navigate = useNavigate();
    const [usernameNotFound, setUsernameNotFound] = useState(false);

    useEffect(() => {
        // console.log("user: ", user);
        if (!user) {
            return;
        }
        if (user?.emailVerification) {
            navigate("/account");
        } else {
            navigate("/verify");
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const email = registerForm.current.email.value;
        const password = registerForm.current.password.value;
        const userInfo = { email, password };

        if (email.length > 0 && password.length) {
            const success = await registerUser(userInfo);
            if (success) {
                console.log("Signed-up succesfully");
            }
        } else {
            return; // add proper handling
        }
    };

    // Dosen't get triggered because the appState reload and overwrite the appPage but is caught by the default case
    // SOLUTION : when the user is done signing uo redirect to loaclhost/setup
    const handleConfirm = async (e) => {
        e.preventDefault();
        console.log("Ran SETUP with signup component");
        const chesscomUsername = setupForm.current.chesscom.value;
        if (!setChesscom) {
            return; // not signed in
        }
        if (chesscomUsername.length === 0) {
            return;
        }
        const response = await setChesscom(chesscomUsername);
        if (response) {
            console.log("[SUCCES] setting chess.com username ");
            navigate("/");
        } else {
            console.log("[ERROR] setting chess.com username was not succesful");
            setUsernameNotFound(true);
        }
    };

    const handleOneClickSetup = () => {
        window.location.href = "https://www.chess.com/home?setup=true";
    };

    return !settingUp ? (
        <>
            <title>Sign Up | Oakmate</title>
            <meta
                name="description"
                content="Create your Oakmate account to unlock a lifetime of advanced chess analysis and save your progress."
            />
            <div className="authPage">
                <div className="auth">
                    <div className="auth-component">
                        <img
                            src={logoPng}
                            alt="logoPng"
                            className="logoPng"
                            onClick={() => navigate("/")}
                        />
                        <div className="auth-header-wrapper">
                            <div className="auth-header">Create an account</div>
                            <div className="auth-subheader">
                                Already have an account?{" "}
                                <span
                                    className="switchAuthSpan"
                                    onClick={() => {
                                        navigate("/login");
                                        setAuthError(null);
                                    }}
                                >
                                    Log In
                                </span>
                            </div>
                        </div>
                        <form
                            ref={registerForm}
                            onSubmit={handleSubmit}
                            className="auth-form"
                        >
                            <div className="auth-form-main">
                                <label className="form-field glassy-field">
                                    <input
                                        type="email"
                                        placeholder=" "
                                        name="email"
                                        className="form-input"
                                        autoComplete="email"
                                    />
                                    <span className="form-label">
                                        Your Email
                                    </span>
                                </label>

                                <label className="form-field glassy-field">
                                    <input
                                        type="password"
                                        placeholder=" "
                                        name="password"
                                        className="form-input"
                                        autoComplete="current-password"
                                    />
                                    <span className="form-label">Password</span>
                                </label>
                            </div>

                            <button
                                type="submit"
                                value="Register"
                                className="submit-btn"
                                onClick={handleSubmit}
                            >
                                Sign Up
                            </button>

                            {authError && (
                                <div className="autoFailed">{authError}</div>
                            )}
                        </form>
                        <div className="or-wrapper">
                            <div className="auth-separator" />
                            <div className="auth-or-text">OR</div>
                            <div className="auth-separator" />
                        </div>
                        <button
                            className="signInGoogle"
                            onClick={() => {
                                const baseUrl = getBaseUrl();
                                account.createOAuth2Session(
                                    "google",
                                    `${baseUrl}/?oauth_success=google`, // Add parameter
                                    `${baseUrl}/fail`
                                );
                            }}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="googleIcon"
                            >
                                <path
                                    d="M8 0.380859C9.90889 0.380859 11.5183 1.02914 12.7959 2.10449L11.042 3.85742C10.1829 3.16342 9.14463 2.80469 8 2.80469C5.74333 2.8047 3.83968 4.32568 3.15918 6.35938H3.1582C2.98685 6.87343 2.88477 7.42337 2.88477 8C2.88477 8.57661 2.98685 9.12656 3.1582 9.64062H3.15918C3.83937 11.6734 5.74243 13.2031 8 13.2031C9.1466 13.2031 10.1302 12.8914 10.9102 12.3662C11.8435 11.7436 12.4711 10.8136 12.6797 9.71484L12.7656 9.2627H8.38086V6.92676H15.209C15.2669 7.33165 15.2988 7.74976 15.2988 8.18164C15.2988 10.5247 14.4615 12.4693 13.0361 13.7852C11.7892 14.9362 10.0732 15.6191 8 15.6191C5.02346 15.6191 2.453 13.9028 1.19824 11.4141V11.4131L1.01367 11.0225C0.608752 10.0977 0.380859 9.0781 0.380859 8C0.380862 6.76774 0.678703 5.61214 1.19824 4.58691V4.58594C2.45276 2.09074 5.02296 0.380866 8 0.380859Z"
                                    stroke="white"
                                    strokeWidth="0.761907"
                                />
                            </svg>
                            <div className="signInGoogle-text">
                                Sign in with Google
                            </div>
                        </button>
                        <p className="terms">
                            You acknowledge that you read, and agree, to <br />{" "}
                            our{" "}
                            <span className="terms-detail">
                                Terms of Service
                            </span>{" "}
                            and our{" "}
                            <span className="terms-detail">Privacy Policy</span>
                        </p>
                    </div>
                </div>
            </div>
        </>
    ) : (
        <>
            <title>Sign Up | Oakmate</title>
            <meta
                name="description"
                content="Create your Oakmate account to unlock a lifetime of advanced chess analysis and save your progress."
            />
            <div className="authPage">
                <div className="auth">
                    <div className="auth-component">
                        <div className="auth-header-wrapper">
                            <div className="auth-header">Quick Setup</div>
                            <div className="auth-subheader">
                                Set your chess platforms infos
                            </div>
                        </div>
                        <form
                            ref={setupForm}
                            onSubmit={handleConfirm}
                            className="auth-form"
                            autoComplete="off"
                        >
                            <div className="auth-form-main">
                                <label className="form-field glassy-field">
                                    <input
                                        type="text"
                                        placeholder=" "
                                        name="chesscom"
                                        className="form-input"
                                        autoComplete="off"
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        spellCheck={false}
                                        inputMode="text"
                                    />
                                    <span className="form-label">
                                        Chess.com's username
                                    </span>
                                </label>
                            </div>

                            <button
                                type="submit"
                                value="Register"
                                className="submit-btn"
                                onClick={handleConfirm}
                            >
                                Confirm
                            </button>
                            <div className="forgot-password">
                                What is my username?
                            </div>
                        </form>
                        <div className="or-wrapper">
                            <div className="auth-separator" />
                            <div className="auth-or-text">OR</div>
                            <div className="auth-separator" />
                        </div>
                        <button className="signInGoogle">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.0003 3.6H7.12031C5.32814 3.6 4.43139 3.6 3.74688 3.94878C3.14476 4.25557 2.65557 4.74476 2.34878 5.34688C2 6.03139 2 6.92814 2 8.72031V20.8803C2 22.6725 2 23.5681 2.34878 24.2526C2.65557 24.8547 3.14476 25.3448 3.74688 25.6516C4.43072 26 5.32639 26 7.11505 26H19.2849C21.0736 26 21.968 26 22.6518 25.6516C23.254 25.3448 23.7448 24.8543 24.0516 24.2521C24.4 23.5683 24.4 22.6736 24.4 20.8849V18M26 10V2M26 2H18M26 2L14.8 13.2"
                                    stroke="#DEDEDD"
                                    strokeWidth="2.4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                            <div
                                className="signInGoogle-text"
                                onClick={handleOneClickSetup}
                            >
                                One Click Setup
                            </div>
                        </button>
                        {usernameNotFound ? (
                            <div className="autoFailed">
                                Username not found, <br /> please double check
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    );
}
